<template>
    <el-scrollbar class="scrollbar-content" :native="false">
        <div class="brandDetail-content">
        <el-breadcrumb separator="/" class="student-breadcrumb">
            <el-breadcrumb-item>采购管理</el-breadcrumb-item>
            <el-breadcrumb-item>数据分析</el-breadcrumb-item>
            <el-breadcrumb-item>商品榜单</el-breadcrumb-item>
            <el-breadcrumb-item>品牌榜单</el-breadcrumb-item>
            <el-breadcrumb-item>品牌详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="page-title">品牌详情</div>
        <div class="goods-overview">
            <div class="title">商品概况</div>
            <div class="overview-content">
                <div class="oo-item">
                    <div class="oo-title">
                        <img src="../../../../assets/images/student/good-detail-brand.png" alt="">
                        <p>品牌排名</p>
                    </div>
                    <div class="oo-right">
                        <div class="item">
                            <p class="text">按成交金额排行</p>
                            <p class="num">{{turnoverIndex}}</p>
                        </div>
                        <div class="item">
                            <p class="text">按点击指数排名</p>
                            <p class="num">{{click_num}}</p>
                        </div>
                    </div>
                </div>
                <div class="oo-item">
                    <div class="oo-title">
                        <img src="../../../../assets/images/student/good-icon-03.png" alt="">
                        <p>店铺商品</p>
                    </div>
                    <div class="oo-right">
                        <div class="item">
                            <p class="text">动销商品数</p>
                            <p class="num" v-if="brandDetail">{{brandDetail.moving_goods}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overview-content">
                <div class="oo-item">
                    <div class="oo-title">
                        <img src="../../../../assets/images/student/good-icon-01.png" alt="">
                        <p>引流漏斗</p>
                    </div>
                    <div class="oo-right">
                        <div class="item">
                            <p class="text">浏览量</p>
                            <p class="num" v-if="brandDetail">{{brandDetail.all_searcher}}</p>
                        </div>
                        <div class="item">
                            <p class="text">成交件数指数</p>
                            <p class="num" v-if="brandDetail">{{brandDetail.all_transaction_volume}}</p>
                        </div>
                        <div class="item">
                            <p class="text">点击指数</p>
                            <p class="num" v-if="brandDetail">{{brandDetail.all_click_num}}</p>
                        </div>
                    </div>
                </div>
                <div class="oo-item">
                    <div class="oo-title">
                        <img src="../../../../assets/images/student/good-icon-01.png" alt="">
                        <p>成交转化</p>
                    </div>
                    <div class="oo-right">
                        <div class="item">
                            <p class="text">成交金额指数</p>
                            <p class="num" v-if="brandDetail">{{brandDetail.all_transaction_amount}}</p>
                        </div>
                        <div class="item">
                            <p class="text">成交单量指数</p>
                            <p class="num" v-if="brandDetail">{{brandDetail.all_transaction_volume}}</p>
                        </div>
                        <div class="item">
                            <p class="text">成交转化率</p>
                            <p class="num" v-if="brandDetail">{{brandDetail.all_transaction_conversion}}%</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="page-title">趋势图</div>
        <div class="trend-wrapper">
            <div class="trend-category">
                <div class="cate-left">
                    <p>品牌排名</p>
                    <p>引流漏斗</p>
                    <p>成交转化</p>
                </div>
                <div class="cate-right">
                    <el-checkbox-group v-model="checkList" :max="4">
                        <el-checkbox :label="checkItem" v-for="checkItem in categoryList" :key="checkItem"></el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div class="choose-number">
                已选择:
                <span class="number">
                    <span>{{checkList.length}}</span> / 4
                </span>
            </div>
            <div class="trend-content" id="trendECharts"></div>
        </div>
    </div>
    </el-scrollbar>
</template>

<script>
    import {tranPurchaseBrandTopDetail} from '@/utils/apis'
    export default {
        data() {
            return {
                brandId: Number(this.$route.query.id) || '',
                brandDetail: {},
                trendECharts: null,
                checkList: ['按成交金额排名', '浏览量', '成交单量指数', '成交客单价指数'],
                categoryList: [
                    '按成交金额排名', '按点击指数排名', '浏览量', '点击指数', '成交单量指数', '成交件数指数', '成交金额指数', '成交客单价指数', '成交转化率'],
                allSeries: [],
                turnoverIndex:'',
                click_num:'',
            }
        },
        mounted() {
            this.getBrandDetail()
            this.trendECharts = this.$echarts.init(document.getElementById('trendECharts'));
            this.getTrendECharts()
            let resizeTimer = null;
            window.onresize = () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    this.trendECharts.resize()
                }, 100)
            }
        },
        computed: {
            series() {
                return this.allSeries.filter(item => {
                    return this.checkList.includes(item.name)
                })
            }
        },
        watch: {
            series(val) {
                this.getTrendECharts()
            }
        },
        methods: {
            // 获取品牌详情
            getBrandDetail() {
                let param ={
                    brand:this.$route.query.brand
                }
                if (this.$route.query.op_id) {
                    param.op_id = this.$route.query.op_id;
                }
                if (this.$route.query.course_id) {
                    param.course_id = this.$route.query.course_id;
                }
                tranPurchaseBrandTopDetail(param).then((res) => {
                    this.brandDetail = res.data
                    this.click_num = res.data.top.click_num
                    this.turnoverIndex = res.data.top.turnoverIndex
                    this.allSeries = [
                        {
                            name: '按成交金额排名',
                            type: 'line',
                            data: this.brandDetail.TopTurnoverIndex,
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: "#000",
                                }
                            },
                            yAxisIndex: 0,
                        },
                        {
                            name: '按点击指数排名',
                            type: 'line',
                            data: this.brandDetail.TopClickNum,
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: "#d6006a",
                                }
                            },
                            yAxisIndex: 1,
                        },
                        {
                            name: '浏览量',
                            type: 'line',
                            data: this.brandDetail.view_num,
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: "#FFAC76",
                                }
                            },
                            yAxisIndex: 2,
                        },
                        {
                            name: '点击指数',
                            type: 'line',
                            data: this.brandDetail.click_num,
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: "#ffea00",
                                }
                            },
                            yAxisIndex: 3,
                        },
                        {
                            name: '成交单量指数',
                            type: 'line',
                            data: this.brandDetail.volumeIndex,
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: "#26C6DA",
                                }
                            },
                            yAxisIndex: 4,
                        },
                        {
                            name: '成交件数指数',
                            type: 'line',
                            data: this.brandDetail.number_of_trades_index,
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: "#0084FF",
                                }
                            },
                            yAxisIndex: 5,
                        },
                        {
                            name: '成交金额指数',
                            type: 'line',
                            data: this.brandDetail.turnoverIndex,
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: "#E43C3E",
                                }
                            },
                            yAxisIndex: 6,
                        },
                        {
                            name: '成交客单价指数',
                            type: 'line',
                            data: this.brandDetail.unit_price,
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: "#00d619",
                                }
                            },
                            yAxisIndex: 7,
                        },
                        {
                            name: '成交转化率',
                            type: 'line',
                            data: this.brandDetail.transaction_conversion,
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: "#4600d6",
                                }
                            },
                            yAxisIndex: 8,
                        },
                    ]
                }).catch((err)  => {
                    console.log(err);
                })
            },
            // 趋势图
            getTrendECharts() {
                this.trendECharts.setOption({
                    xAxis: {
                        type: 'category',
                        data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                        boundaryGap: false,
                        axisLabel: {
                            textStyle: {
                                color: '#666'
                            },
                            align: 'center'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        },
                    },
                    yAxis: [{
                        type: 'value',
                        name: '按成交金额排名',
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        }
                    }, {
                        type: 'value',
                        name: '按点击指数排名',
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        }
                    }, {
                        type: 'value',
                        name: '浏览量',
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        }
                    }, {
                        type: 'value',
                        name: '点击指数',
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        }
                    }, {
                        type: 'value',
                        name: '成交单量指数',
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        }
                    }, {
                        type: 'value',
                        name: '成交件数指数',
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        }
                    }, {
                        type: 'value',
                        name: '成交金额指数',
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        }
                    }, {
                        type: 'value',
                        name: '成交客单价指数',
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        }
                    }, {
                        type: 'value',
                        name: '成交转化率',
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F3F6FA'
                            }
                        }
                    }],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'none',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        },
                        backgroundColor: '#fff',
                        textStyle: {
                            color: '#666',
                        },
                        borderColor: '#DCDCDC',
                        borderWidth: 2,
                        formatter: (params) => {
                            let res = params[0].name;
                            for (let i = 0; i < params.length; i++) {
                                if (params[i].seriesName === '成交转化率') {
                                    res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + '%';
                                } else {
                                    res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value;
                                }
                            }
                            return res
                        }
                    },
                    legend: {
                        icon: 'circle',
                        // data: this.checkList,
                        bottom: 0,
                        selectedMode: false
                    },
                    grid: {
                        top: 10,
                        left: 10,
                        right: 20,
                        bottom: 80,
                    },
                    series: this.series
                }, true);
            },
        }
    }
</script>

<style scoped lang="scss">
    .scrollbar-content{
        height: calc(100vh - 200px);
        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }
    .page-title {
        font-size: 20px;
        font-weight: 500;
        color: #333;
        margin: 20px 0;
        line-height: 1;
    }
    .goods-overview {
        margin-top: 20px;
        background: #fff;
        padding: 20px;
        .title {
            font-size: 16px;
            line-height: 1;
        }
        .overview-content {
            margin-top: 20px;
            border: 1px solid #E5E5E5;
            display: flex;
            .oo-item {
                width: 50%;
                display: flex;
                align-items: center;
                .oo-title {
                    width: 112px;
                    height: 112px;
                    background: #F8F8F8;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img {
                        width: 42px;
                        margin-bottom: 2px;
                    }
                }
                .oo-right {
                    width: 1%;
                    flex: 1;
                    display: flex;
                    .item {
                        width: 33.333333%;
                        padding-left: 20px;
                        p {
                            line-height: 1;
                            white-space: nowrap;
                        }
                        .text {
                            font-size: 16px;
                        }
                        .num {
                            font-size: 18px;
                            margin-top: 20px;
                        }
                    }
                }
            }
        }
    }
    .trend-wrapper {
        background: #fff;
        padding: 20px;
        .trend-category {
            display: flex;
            border: 1px solid #E5E5E5;
            border-top: 0;
            .cate-left {
                width: 120px;
                background: #F8F8F8;
                border-top: 1px solid #E5E5E5;
                p {
                    line-height: 50px;
                    text-align: center;
                    font-size: 16px;
                    border-bottom: 1px solid #E5E5E5;
                    margin: 0;
                    &:last-child {
                        border-bottom: 0;
                    }
                }
            }
            .cate-right {
                width: 1%;
                flex: 1;
                .el-checkbox-group {
                    display: flex;
                    flex-wrap: wrap;
                    .el-checkbox {
                        margin-right: 0;
                        line-height: 50px;
                        padding-left: 48px;
                        width: 15%;
                        box-sizing: border-box;
                        border-top: 1px solid #E5E5E5;
                        &:nth-of-type(2), &:nth-of-type(4) {
                            width: 85%;
                        }
                        &:last-of-type {
                            width: 40%;
                        }
                        /*&:nth-of-type(5) {*/
                        /*    width: 70%;*/
                        /*}*/
                        /*&:nth-of-type(1), &:nth-of-type(2) {*/
                        /*    border-bottom: 1px solid #E5E5E5;*/
                        /*}*/
                    }
                }
            }
        }
        .choose-number {
            margin-top: 30px;
            font-size: 18px;
            .number {
                margin-left: 20px;
                span {
                    color: #0084FF;
                }
            }
        }
        .trend-content {
            margin-top: 30px;
            height: 300px;
        }
        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, ::v-deep.el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #0084FF;
            border-color: #0084FF;
        }
        ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #0084FF;
        }
        ::v-deep .el-checkbox__inner:hover {
            border-color: #0084FF;
        }
    }
</style>